import { Layout, Frame, Page, LegacyStack, Spinner } from '@shopify/polaris';
import {useCallback, useEffect} from 'react';
import { useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import Api from '../../helpers/api';
import OrdersSearch from "../orders/OrdersSearch";

const CustomerOrders = () => {
    const history = useHistory();
    const [customer, setCustomer] = useState(null);
    const {customerId} = useParams();
    const [loading, setLoading] = useState(false);
    const [exportModalActive, setExportModalActive] = useState(false);
    const [user, setUser] = useState();

    useEffect(() => {
        Api
            .getMe()
            .then(({data}) => {
                setUser(data.user);
            })
    }, []);

    useEffect(() => {
        getCustomer(customerId);
    }, [customerId]);

    const getCustomer = (customerId) => {
        Api.getCustomer(customerId)
            .then( response => {
                setCustomer(response.data.data);
            });
    }

    const showCustomer = () => {
        history.push(`/customers/${customerId}`);
    }

    const additionalActions = useCallback(() => {
        return [
            {content: "Shipping Export", onAction: () => setExportModalActive(true)}
        ];
    }, [user]);

    const pageTitle = useCallback(() => {
        if (!customer) {
            return '';
        }

        let name = 'Customer ';

        if (customer.account_number) {
            name += `#${customer.account_number} - `;
        }

        return name + `${customer.first_name} ${customer.last_name}`;
    }, [customer]);

    return (
        <Frame>
            <Page title={pageTitle()}
                  primaryAction={{
                      content: 'View Customer',
                      onAction: showCustomer,
                  }}
                  secondaryActions={additionalActions()}
                  backAction={{ content: 'Go back', onAction: () => history.goBack() }}
            >
                <Layout>
                    <OrdersSearch
                        loading={loading}
                        setLoading={setLoading}
                        customerId={customerId}
                        searchTitle={"Search orders by Order Number"}
                        exportModalActive={exportModalActive}
                        setExportModalActive={setExportModalActive}
                    />
                </Layout>
            </Page>
        </Frame>
    );
}

export default CustomerOrders;
